import PropTypes from 'prop-types';
import React from 'react';

const SearchIcon = ({ color }) => (
  <svg width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fillRule="evenodd" clipRule="evenodd" d="M15.4072 2.12891C5.86568 6.6953 0.812568 14.0781 0.109969 24.4791C-0.228837 29.4933 0.151945 31.637 2.1468 35.9726C6.72019 45.9089 14.07 50.949 24.9018 51.5776C30.5366 51.9054 32.1596 51.5676 37.1368 49.0361C43.0484 46.0288 43.8909 45.9918 43.8909 48.7333C43.8909 49.6148 48.3884 54.8158 53.8852 60.2917L63.8795 70.248L67.1087 67.0188L70.3378 63.7897L60.3815 53.7954C54.9056 48.2985 49.7046 43.8011 48.8231 43.8011C46.1646 43.8011 45.8548 42.6637 47.7657 39.9163C56.2739 27.6833 50.9229 8.91503 37.0029 2.16989C35.019 1.20844 30.4736 0.267979 26.9007 0.080086C21.6377 -0.197755 19.4559 0.192022 15.4072 2.12891ZM35.4747 10.8689C46.2876 17.5511 46.0807 34.1996 35.1 40.9857C30.0059 44.1339 21.7966 44.1339 16.7025 40.9857C6.92507 34.9431 5.34098 21.4529 13.4553 13.3385C15.3602 11.4336 18.3775 9.42974 20.1605 8.88705C24.631 7.52583 31.505 8.41532 35.4747 10.8689Z" fill={color} />
  </svg>

);

SearchIcon.propTypes = {
  color: PropTypes.string.isRequired,
};

export default SearchIcon;
